export const environment = {
	production: false,
	baseHref: '/',
	authenticationUrl: 'https://mobile-auth.prod.ag2goservices.amgreetings.com/api/auth',
	webApi: 'https://api.mdm.qas.amgreetings.com',
	userRolesAuthorization: false,
	tablePaginationSizes: [250, 50, 100],
	pageableAllItems: 99999,
	noLoadingSpinnerHeader: 'loading-spinner-disabled',
	httpRequestChunkSize: 100
};
